import { z } from "zod";

import { temporalDataPointSchema } from "@/components/ui/chart/types/temporal-chart-series.type";
import { EDataUnit } from "@/constants/data-units.type";

export enum EConsumptionDistributionApplianceCategories {
  HEATER = "HEATER",
  WATER_HEATER = "WATER_HEATER",
  AIR_CONDITIONING_COOLING = "AIR_CONDITIONING_COOLING",
  HEAT_PUMP = "HEAT_PUMP",
  OTHER = "OTHER",
}

export enum EMainConsumptionSource {
  DSO = "DSO",
  DEVICES = "DEVICES",
}

export const wattHourValueSchema = z.object({
  value: z.number().nullable(),
  unit: z.literal(EDataUnit.WATT_HOUR),
});

export type TWattHourValue = z.infer<typeof wattHourValueSchema>;

export const commonConsumptionSchema = z.object({
  global: wattHourValueSchema,
  globalByDay: z.object({
    value: z.array(temporalDataPointSchema),
    unit: z.literal(EDataUnit.WATT_HOUR),
  }),
  globalCost: z.object({
    value: z.number().nullable(),
    unit: z.literal(EDataUnit.EURO),
  }),

  totalDevices: wattHourValueSchema,
  devicesByDay: z.object({
    value: z.array(temporalDataPointSchema),
    unit: z.literal(EDataUnit.WATT_HOUR),
  }),
  devicesByCategory: z.object({
    value: z.array(
      z.object({
        category: z.string(),
        consumption: z.number().nullable(),
      }),
    ),
    unit: z.literal(EDataUnit.WATT_HOUR),
  }),
  devicesCount: z.number(),

  totalEvolution: z.object({
    value: z.number().nullable(),
    unit: z.literal(EDataUnit.PERCENT),
  }),
  totalPerArea: wattHourValueSchema,

  mainConsumptionSource: z.nativeEnum(EMainConsumptionSource),
});

export type TCommonConsumption = z.infer<typeof commonConsumptionSchema>;
